import { createContext, useContext } from "react";

export const defaultRemoteConfig = {
	brandedLogo: false,
	latestVersion: "1.4.14",
	logRocket: true,
	intercom: false,
	zendesk: false,
	deals: {
		strategy: "cms",
		urls: null,
		translationLabel: "nav.deals",
	},
};

export type RemoteConfig = typeof defaultRemoteConfig;

const RemoteConfigContext = createContext<RemoteConfig>(defaultRemoteConfig);
export default RemoteConfigContext;

export const useRemoteConfig = (): RemoteConfig => {
	return useContext(RemoteConfigContext);
};
